
import { Options, Vue } from "vue-class-component";
import VoucherService from "../../service/VoucherService.js";
import ProfilerService from "../../service/ProfilerService.js";
import ChartService from "../../service/ChartService.js";
import PermissionService from "../../service/PermissionService.js";
import { reactive } from "vue";
import useVuelidate from "@vuelidate/core";
import { required, minLength, maxLength } from "@vuelidate/validators";
import Toaster from "../../helpers/Toaster";
import moment from "moment";
import AutoComplete from "primevue/autocomplete";
import SearchFilter from "../../components/SearchFilter.vue";
import PreviewReceipt from "../../components/PreviewReceipt.vue";
import PaymentScreen from "../../components/PaymentScreen.vue";
import { useStore, ActionTypes } from "../../store";
import CashierSession from "../../service/CashierSession.js";

interface accountHead {
  id: Number,
  account_name: String
}


const PAYMENT_ACCOUNT_MAP = {
  Cash: { accountID: 2, accountHead: "Cash in hand" },
  Cheque: { accountID: 8, accountHead: "Cash at bank" },
};

function resolvePaymentAccount(paymentType: string) {
  if (PAYMENT_ACCOUNT_MAP[paymentType]) {
    return PAYMENT_ACCOUNT_MAP[paymentType];
  }
  if (paymentType === "SupplierCredit" || paymentType === "SupplierCreditClaim") {
    return null; 
  }

  return { accountID: 8, accountHead: "Cash at bank" };
}

const PAYABLE_EXPENSES_ACCOUNT_NAME = "Payable Expenses";

@Options({
  title: 'Other Expenses',
  components: {
    AutoComplete,
    SearchFilter,
    PreviewReceipt,
    PaymentScreen,
  },
})
export default class OtherVoucher extends Vue {
  private lists = [];
  private profilerList = [];
  private store = useStore();
  private accountHeadList : accountHead[] = [];
  private payableExpensesAccountID = 0;
  private statement = "";
  private dialogTitle = "";
  private toast;
  private goToFirstLink = 0;
  private previewHeading = "";
  private receiptID = 0;
  private voucherService;
  private profilerService;
  private chartService;
  private previewImageDialog = false;
  private productDialog = false;
  private filterDialog = false;
  private submitted = false;
  private statusDialog = false;
  private checkPagination = true;
  private totalRecords = 0;
  private limit = 0;
  private permissions;
  private home = { icon: "pi pi-home", to: "/" };
  private items = [
    { label: "Initialization", to: "/home/initialization" },
    { label: "Other Expenses", to: "other-voucher" },
  ];
  private cashierSessionSerice;

  private paymentDialogOpen = false;
  private settleMode = false;
  private settlePaymentDialogOpen = false;
  private settleTarget: any = null;

  private menuBar = false;
  private selectedVoucher: any = {};
  private previewHistoryDialog = false;
  private voucherHistoryList: any[] = [];
  private paymentCompleted = false;

  private itemFilter = {
    keyword: "",
    filterType: "None",
    storeID: 0,
    date1: "",
    date2: "",
    type: "EXV",
    userID: 0,
  };

  private item = {
    id: 0,
    transactionID: 0,
    status: "Active",
    profileID: 3,
    totalAmount: 0,
    type: "EXV",
  };

  private state = reactive({
    description: "",
    voucherDate: "",
    selectedProfile: "",
    itemList: [
      {
        accountID: 0,
        accountHead: "",
        totalAmount: 0,
        type: "",
      },
    ],
  });

  private validationRules = {
    description: {
      required,
    },
    voucherDate: {
      required,
    },
  };

  private v$ = useVuelidate(this.validationRules, this.state);

  private voucherTypes = [
    { key: "EXV", value: "Expense Voucher" },
  ];

  get editVoucherPermission(){
    if(this.permissions.can('edit_other_voucher')){
      return true;
    }
    return false;
  }

  onPage(event) {
    this.loadList(event.first);
  }

  created() {
    this.voucherService = new VoucherService();
    this.profilerService = new ProfilerService();
    this.chartService = new ChartService();
    this.toast = new Toaster();
    this.permissions =  new PermissionService();
  }

  mounted() {
    this.loadList(0);
    this.cashierSessionSerice = new CashierSession();
    this.getPageData();

    window.addEventListener('keypress', this.handleKeypress);
  }
  
  beforeUnmount() {
  window.removeEventListener('keypress', this.handleKeypress);
  }

  handleKeypress(event) {
      if (event.key === 'Enter') {
        this.loadList(this.goToFirstLink);
      } else {
      }
    } 

  getPageData()
  {
    this.voucherService.getPageData().then((res) => {
      const payable = (res.accounts || []).find(
        (a: any) => a.account_name === PAYABLE_EXPENSES_ACCOUNT_NAME
      );
      if (payable) {
        this.payableExpensesAccountID = payable.id;
      }

      this.accountHeadList = (res.accounts || []).filter(
        (a: any) => a.account_name !== PAYABLE_EXPENSES_ACCOUNT_NAME
      );
    });
  }

  openDialog() {
    this.cashierSessionSerice.keepAliveCashierSession()
      .then((res) => {
        if(res.status_id != 1){
          this.toast.showError('Please login to cashier session before proceed');
        } else {

          this.clearItem();
          this.submitted = false;
          this.dialogTitle = "Create Voucher";
          this.productDialog = true;
        }
      });
  }

  openFilterDialog() {
    this.dialogTitle = "Filter Vouchers";
    this.filterDialog = true;
  }

  hideDialog() {
    this.productDialog = false;
    this.submitted = false;
  }

  proceedToPayment(isFormValid) {
    this.submitted = true;
    if (isFormValid && this.validateHeadList.length == 0) {
      this.productDialog = false;
      this.store.dispatch(ActionTypes.TOTAL_BILL, this.totalVoucherAmount);

      this.paymentDialogOpen = true;
    }
  }

  closePaymentScreen() {
      this.paymentDialogOpen = false;

      if (!this.paymentCompleted) {
          this.productDialog = true;  
      }
      this.paymentCompleted = false;   
  }

  handleVoucherPayments(paymentList) {
    this.paymentCompleted = true;
    this.paymentDialogOpen = false;
    this.productDialog = false;
    this.setAccountingEntries(paymentList);

    this.state.voucherDate = moment(this.state.voucherDate).format("YYYY-MM-DD");

    if (this.item.id != 0) {
      this.voucherService.update(this.item, this.state, paymentList).then((res) => {
        this.loadList(this.goToFirstLink);
        this.toast.handleResponse(res);
      });
    } else {
      this.voucherService.save(this.item, this.state, paymentList).then((res) => {
        this.goToFirstLink = 0;
        this.loadList(this.goToFirstLink);
        this.toast.handleResponse(res);
      });
    }

    this.clearItem();
  }

  openSettleDialog(data) {
    this.settleTarget = data;
    this.settleMode = true;
    this.store.dispatch(ActionTypes.TOTAL_BILL, Number(data.balance));

    this.settlePaymentDialogOpen = true;
  }

  openMenu(data) {
    this.selectedVoucher = data;
    this.menuBar = true;
  }

  closeSettleDialog() {
    this.settlePaymentDialogOpen = false;
    this.settleMode = false;
    this.settleTarget = null;
  }

  handleSettlePayments(paymentList) {
    if (!this.settleTarget) {
      this.closeSettleDialog();
      return;
    }

    const settleItemList: any[] = [];

    paymentList.forEach((p) => {
      const mapping = resolvePaymentAccount(p.paymentType);
      if (mapping) {
        settleItemList.push({
          accountID: mapping.accountID,
          accountHead: mapping.accountHead,
          totalAmount: p.transTotalAmount,
          type: "Credit",
        });
      }
    });

    const totalSettled = settleItemList.reduce((sum, e) => sum + Number(e.totalAmount), 0);

    settleItemList.unshift({
      accountID: this.payableExpensesAccountID,
      accountHead: PAYABLE_EXPENSES_ACCOUNT_NAME,
      totalAmount: totalSettled,
      type: "Debit",
    });

    this.voucherService.settlePayable(this.settleTarget.id, settleItemList, paymentList).then((res) => {
      this.loadList(this.goToFirstLink);
      this.toast.handleResponse(res);
    });

    this.closeSettleDialog();
  }

  saveItem(isFormValid) {

    this.proceedToPayment(isFormValid);
  }

  editIem(data) {
    this.cashierSessionSerice.keepAliveCashierSession()
      .then((res) => {
        if(res.status_id != 1){
          this.toast.showError('Please login to cashier session before proceed');
        } else {
                  
            this.submitted = false;
            this.dialogTitle = "Update Voucher";
            this.productDialog = true;

            this.voucherService.getItem(data).then((res) => {
              if (res != null) {
                this.item.id = res.voucher.id;
                this.state.selectedProfile = res.voucher.profile_name;
                this.state.voucherDate = res.voucher.voucher_date;
                this.state.description = res.voucher.memo;
                this.item.profileID = res.voucher.profile_id;
                this.item.transactionID = res.voucher.transaction_id;
                this.item.totalAmount = res.voucher.total_amount;
                this.item.type = res.voucher.type;
                this.item.status = res.voucher.status;

                let vList = res.voucherList;
                if (vList.length > 0) {
                  this.state.itemList = [];
                  vList.map((v) => {
                    if (
                      v.type == "Debit" &&
                      (res.voucher.type == "DBV" || res.voucher.type == "EXV")
                    ) {
                      this.state.itemList.push({
                        accountID: Number(v.account_id),
                        accountHead: v.account_name,
                        totalAmount: Number(v.amount),
                        type: v.account_type,
                      });
                    } else if (v.type == "Credit" && res.voucher.type == "CRV") {
                      this.state.itemList.push({
                        accountID: Number(v.account_id),
                        accountHead: v.account_name,
                        totalAmount: Number(v.amount),
                        type: v.account_type,
                      });
                    } else {
                      //NO THING
                    }
                  });
                }
              }
            });
            
        }
      });
  }

  //FETCH THE DATA FROM SERVER
  loadList(page) {
    this.voucherService.getItems(this.itemFilter, page).then((data) => {
      this.lists = data.records;
      this.totalRecords = data.totalRecords;
      this.limit = data.limit;
      this.statement = data.statement;
    });
  }

  clearItem() {
    this.item.id = 0;
    this.item.profileID = 3;
    this.item.status = "Active";
    this.state.description = "";
    this.state.voucherDate = "";
    this.state.selectedProfile = "";

    this.state.itemList = [];
    this.state.itemList.push({
      accountID: 0,
      accountHead: "",
      totalAmount: 0,
      type: "",
    });
  }

  loadSearchData() {
    this.submitted = true;
    if (this.itemFilter.keyword) {
      this.goToFirstLink = 0;
      this.loadList(this.goToFirstLink);
    }
  }

  searchProfiler(event) {
    setTimeout(() => {
      this.profilerService.searchProfiler(event.query.trim()).then((data) => {
        this.profilerList = data.records;
      });
    }, 500);
  }

  saveProfile(event) {
    const profileInfo = event.value;
    this.state.selectedProfile = profileInfo.account_title;
    this.item.profileID = profileInfo.id;
  }

  searchAccountHead(event) {
    setTimeout(() => {
      this.chartService.searchAccountHead(event.query.trim()).then((data) => {
        this.accountHeadList = data.records;
      });
    }, 500);
  }

  saveAccountHead(event, data) {
    const accountInfo = event.value;
    const record = this.accountHeadList.find(accountHead => accountHead.id === accountInfo);
    data.accountHead = record ? record.account_name:'';
  }

  addNewLine() {
    this.state.itemList.push({
      accountID: 0,
      accountHead: "",
      totalAmount: 0,
      type: "",
    });
  }

  clearLines() {
    this.state.itemList = [];
    this.state.itemList.push({
      accountID: 0,
      accountHead: "",
      totalAmount: 0,
      type: "",
    });

    this.toast.showSuccess("All Items Deleted Successfully");
  }

  clearListItem(item) {
    this.state.itemList.splice(this.state.itemList.indexOf(item), 1);
    this.toast.showSuccess("Item Deleted Successfully");
  }

  get totalVoucherAmount() {
    let totalAmount = 0;
    this.state.itemList.forEach((v) => {
      totalAmount = totalAmount + Number(v.totalAmount);
    });

    this.item.totalAmount = totalAmount;

    return totalAmount;
  }

  get validateHeadList() {
    let invalidListItems: Number[] = [];

    this.state.itemList.map((v, index) => {
      if (v.accountID == 0) {
        invalidListItems.push(index);
      }
    });

    return invalidListItems;
  }

  fixDigits(amt) {
    return Number(amt).toFixed(2);
  }

  formatDate(date) {
    return moment(date).format("DD-MM-YYYY");
  }

  formatDateTime(date) {
    return moment(date).format("DD-MM-YYYY hh:mm A");
  }

  updateFilterStatus(obj) {
    if (obj != null && obj.loading == "Yes") {
      this.itemFilter.filterType = obj.filterName.value;
      this.itemFilter.storeID = obj.storeID.id;
      this.itemFilter.date1 = obj.date1;
      this.itemFilter.date2 = obj.date2;
      this.itemFilter.userID = obj.userID;
      this.itemFilter.keyword = "";
      this.goToFirstLink = 0;
      this.loadList(this.goToFirstLink);
    }
    this.filterDialog = false;
  }

  openPreviewDialog(data) {
    this.previewImageDialog = true;

    if (data.type == "DBV") {
      this.dialogTitle = "Preview Debit Voucher";
      this.previewHeading = "Debit Voucher";
    } else if (data.type == "CRV") {
      this.dialogTitle = "Preview Credit Receipt";
      this.previewHeading = "Credit Voucher";
    } else {
      this.dialogTitle = "Preview Expense Voucher";
      this.previewHeading = "Expense Voucher";
    }

    this.receiptID = data.id;
  }

  updatePreviewStatus() {
    this.previewImageDialog = false;
  }

  setAccountingEntries(paymentList: any[] = []) {

    this.state.itemList.forEach((e) => {
      e.type = "Debit";
    });

    const totalAmount = this.totalVoucherAmount;
    const creditEntries: any[] = [];
    let totalPaid = 0;

    paymentList.forEach((p) => {
      const mapping = resolvePaymentAccount(p.paymentType);
      if (mapping) {
        creditEntries.push({
          accountID: mapping.accountID,
          accountHead: mapping.accountHead,
          totalAmount: p.transTotalAmount,
          type: "Credit",
        });
        totalPaid += Number(p.transTotalAmount);
      }
    });

    const unpaidBalance = this.fixDigitsNumber(totalAmount - totalPaid);

    if (unpaidBalance > 0) {
      creditEntries.push({
        accountID: this.payableExpensesAccountID,
        accountHead: PAYABLE_EXPENSES_ACCOUNT_NAME,
        totalAmount: unpaidBalance,
        type: "Credit",
      });
    }

    this.state.itemList = [...creditEntries, ...this.state.itemList];
  }

  fixDigitsNumber(amt) {
    return Number(Number(amt).toFixed(2));
  }

   get currency() {
    return this.store.getters.getCurrency;
  }

  openHistoryDialog(data) {
    this.voucherService.getVoucherHistory(data.id).then((res) => {
      if (res.status_id == 1) {
        this.voucherHistoryList = res.records;
      } else {
        this.voucherHistoryList = [];
      }
      this.previewHistoryDialog = true;
    });
  }

  get groupedAccountHeadList() {
    const categoryOrder = [
      'Administrative Expenses',
      'Sales & Distribution Expenses',
      'Finance Expenses',
      'Other Expenses',
    ];

    const groups: Record<string, any[]> = {};

    this.accountHeadList.forEach((account: any) => {
      const category = account.expense_type || 'Other Expenses';

      if (!groups[category]) {
        groups[category] = [];
      }
      groups[category].push(account);
    });

    const orderedKeys = [
      ...categoryOrder.filter((c) => groups[c]),
      ...Object.keys(groups).filter((c) => !categoryOrder.includes(c)),
    ];

    return orderedKeys.map((category) => ({
      categoryLabel: category,
      items: groups[category],
    }));
  }

}
